var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.4089,
    height: 12.4089,
    rx: 6.20445,
    fill: "url(#paint0_linear_299_17424)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51123 10.1304C8.08772 10.1304 10.0442 7.16696 10.0442 4.60158C10.0442 4.51865 10.0442 4.43454 10.0406 4.35162C10.4215 4.07588 10.7503 3.7345 11.0115 3.34347C10.6557 3.50035 10.2786 3.60374 9.89254 3.6503C10.2992 3.40723 10.6038 3.02478 10.7496 2.57403C10.3676 2.80038 9.94942 2.95927 9.51345 3.04375C9.22036 2.73161 8.83251 2.52482 8.40999 2.45542C7.98747 2.38603 7.55386 2.45789 7.17632 2.65988C6.79878 2.86188 6.49838 3.18273 6.32166 3.57274C6.14493 3.96275 6.10174 4.40015 6.19878 4.81719C5.42563 4.77842 4.66927 4.57757 3.97875 4.22767C3.28823 3.87776 2.67897 3.38662 2.19048 2.78609C1.9425 3.21439 1.86682 3.72102 1.97881 4.2031C2.0908 4.68518 2.38207 5.10656 2.79347 5.38168C2.48519 5.3712 2.18368 5.28842 1.91327 5.14001V5.16666C1.9138 5.61534 2.06924 6.05008 2.3533 6.39738C2.63736 6.74469 3.03262 6.98326 3.47228 7.07278C3.3054 7.11875 3.13301 7.14167 2.95992 7.1409C2.83789 7.14127 2.7161 7.12996 2.59623 7.10714C2.72049 7.49337 2.96245 7.83106 3.28821 8.07292C3.61398 8.31477 4.00724 8.44867 4.4129 8.45587C3.72376 8.99714 2.87249 9.2907 1.9962 9.28928C1.84179 9.28993 1.68749 9.28103 1.53418 9.26262C2.42357 9.82964 3.45647 10.1307 4.51123 10.1304Z",
    fill: "#565656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_17424",
    x1: 6.20445,
    y1: -2.2336,
    x2: 6.20445,
    y2: 14.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.56534cc899d8a55ff120df0a0189fae5.svg";
export { ForwardRef as ReactComponent };